
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 57 68","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#F2F4F8","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M46.715 14.352c-1.372 0-2.487-1.098-2.487-2.456 0-1.351 1.115-2.449 2.487-2.449 1.38 0 2.494 1.098 2.494 2.449 0 1.358-1.114 2.456-2.494 2.456m-9.344 16.245a12.661 12.661 0 01-8.84 3.62c-3.425 0-6.599-1.352-8.841-3.62-2.243-2.208-3.677-5.333-3.677-8.705s1.373-6.497 3.677-8.705c2.242-2.268 5.416-3.62 8.84-3.62 3.425 0 6.606 1.352 8.841 3.62 2.25 2.208 3.677 5.333 3.677 8.705s-1.366 6.497-3.677 8.705m11.96-25.813h-9.84V3.312c0-1.84-1.494-3.312-3.363-3.312H20.872c-1.869 0-3.364 1.472-3.364 3.312v1.472h-9.84C5.113 4.784 3 6.81 3 9.38v25.023C3 36.913 5.113 39 7.668 39h41.664C51.887 39 54 36.913 54 34.403V9.38c0-2.509-2.113-4.596-4.668-4.596"}}),_c('text',{attrs:{"font-family":"OpenSans-Bold, Open Sans","font-size":"16","font-weight":"bold","transform":"translate(-1)"}},[_c('tspan',{attrs:{"x":"0","y":"64"}},[_v('Update')])])])])
          )
        }
      }
    